import { render, staticRenderFns } from "./issue-status-label.vue?vue&type=template&id=1d598684"
import script from "./issue-status-label.vue?vue&type=script&lang=js"
export * from "./issue-status-label.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports